var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "Dinamik Değişkenler",
        width: "600px",
        footer: null,
      },
      on: { cancel: _vm.onClose },
    },
    [
      _c(
        "div",
        { staticClass: "variables-picker" },
        [
          _c("p", { staticClass: "info-text" }, [
            _vm._v(
              "\n            Kullanmak istediğiniz değişkene tıklayın\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "a-collapse",
            { attrs: { bordered: false, "default-active-key": "task" } },
            [
              _c(
                "a-collapse-panel",
                { key: "task", attrs: { header: "Görev Bilgileri" } },
                [
                  _c(
                    "div",
                    { staticClass: "variables-grid" },
                    _vm._l(_vm.taskVariables, function (variable) {
                      return _c(
                        "div",
                        {
                          key: variable.value,
                          staticClass: "variable-item",
                          on: {
                            click: function ($event) {
                              return _vm.selectVariable(variable.value)
                            },
                          },
                        },
                        [
                          _c("code", { pre: true }, [
                            _vm._v("{{'{{' + variable.value + '}}'}}"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "variable-label" }, [
                            _vm._v(_vm._s(variable.label)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-collapse-panel",
                { key: "relations", attrs: { header: "Görev İlişkileri" } },
                [
                  _c(
                    "div",
                    { staticClass: "variables-grid" },
                    _vm._l(_vm.relationVariables, function (variable) {
                      return _c(
                        "div",
                        {
                          key: variable.value,
                          staticClass: "variable-item",
                          on: {
                            click: function ($event) {
                              return _vm.selectVariable(variable.value)
                            },
                          },
                        },
                        [
                          _c("code", { pre: true }, [
                            _vm._v("{{'{{' + variable.value + '}}'}}"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "variable-label" }, [
                            _vm._v(_vm._s(variable.label)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-collapse-panel",
                { key: "system", attrs: { header: "Sistem Bilgileri" } },
                [
                  _c(
                    "div",
                    { staticClass: "variables-grid" },
                    _vm._l(_vm.systemVariables, function (variable) {
                      return _c(
                        "div",
                        {
                          key: variable.value,
                          staticClass: "variable-item",
                          on: {
                            click: function ($event) {
                              return _vm.selectVariable(variable.value)
                            },
                          },
                        },
                        [
                          _c("code", { pre: true }, [
                            _vm._v("{{'{{' + variable.value + '}}'}}"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "variable-label" }, [
                            _vm._v(_vm._s(variable.label)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }